import axios from "axios";
import { BASE_URL, SERVER_NAME } from "./Constants";

import {
  getToken,
  logOut,
  refreshToken,
  setUser,
} from "../components/Login/Users-Api";

const HTTP = axios.create({ baseURL: BASE_URL });
HTTP.defaults.maxRedirects = 0;

// Agrega el token a todas las peticiones
HTTP.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Límite de reintentos
const MAX_RETRIES = 5;

HTTP.interceptors.response.use(
  async (response) => {
    const originalRequest = response.config;

    // Caso especial: servidor redirige a login (302) en vez de dar 403/401
    if (
      originalRequest?.baseURL === BASE_URL &&
      response.request?.responseURL === SERVER_NAME + "login"
    ) {
      originalRequest._retryCount = originalRequest._retryCount || 0;

      if (originalRequest._retryCount >= MAX_RETRIES) {
        logOut();
        return Promise.reject("Máximo número de reintentos alcanzado.");
      }

      originalRequest._retryCount += 1;

      try {
        const tokenResponse = await refreshToken();
        setUser(tokenResponse);
        const newToken = getToken();

        if (!newToken) {
          logOut();
          return Promise.reject("Token no disponible tras renovación.");
        }

        return HTTP(originalRequest); // Reintenta
      } catch (e) {
        logOut();
        return Promise.reject("No se pudo renovar token tras redirección.");
      }
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Aseguramos que haya un objeto originalRequest válido
    if (!originalRequest) return Promise.reject(error);

    originalRequest._retryCount = originalRequest._retryCount || 0;

    // Ya alcanzó el máximo
    if (originalRequest._retryCount >= MAX_RETRIES) {
      logOut();
      return Promise.reject("Máximo número de reintentos alcanzado.");
    }

    // Errores de red
    if (error.message === "Network Error") {
      console.warn("Error de red detectado");
      originalRequest._retryCount += 1;
      return HTTP(originalRequest); // Podrías aplicar lógica especial aquí
    }

    // Errores 401: probablemente token expirado
    if (error.response && (error.response.status === 403 || error.response.status === 401)){
      originalRequest._retryCount += 1;
      try {
        const tokenResponse = await refreshToken();
        setUser(tokenResponse);
        return HTTP(originalRequest);
      } catch (e) {
        logOut();
        return Promise.reject("Token expirado y no pudo renovarse.");
      }
    }

    // Otros errores (403, 500, etc)
    return Promise.reject(error);
  }
);

export default HTTP;
